<template>
  <div>
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row>
              <el-col :span="6">
                <el-form-item label="课程名称：">
                  <el-input size="small" v-model="form.courseName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="姓名：">
                  <el-input size="small" v-model="form.uname"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户名：">
                  <el-input size="small" v-model="form.fullName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="type" label="类型：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.type"
                    placeholder="-不限-"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in typeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search">
                  确定
                </el-button>
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll"> 清空 </el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">筛选</el-button>
        <el-button type="primary" @click="exportLearnRecord" v-if="roleType != 60"
          >导出筛选结果</el-button
        >
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column prop="uname" label="用户名" align="center">
      </el-table-column>
      <el-table-column prop="fullname" label="姓名" align="center">
      </el-table-column>
      <el-table-column
        prop="courseName"
        label="课程名称"
        sortable="custom"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="sectionName"
        label="章节名称"
        align="center"
      ></el-table-column>
      <el-table-column label="学习累计时长（分）" prop="studytime">
        <template slot-scope="scope">
          <div v-if="scope.row.studytime">
            {{ Math.round(scope.row.studytime / 60) }}
          </div>
        </template>
        <!-- <template slot-scope="scope">
          <div v-if="scope.row.learnfinish === 0">
            {{ scope.row.truetime }} / {{ scope.row.totaltime }}
          </div>
          <div v-else>
            {{ scope.row.totaltime }} / {{ scope.row.totaltime }}
          </div>
        </template> -->
      </el-table-column>
      <el-table-column prop="learnfinish" label="学习状态">
        <template slot-scope="scope">
          <div v-if="scope.row.learnfinish === 0">学习中</div>
          <div v-if="scope.row.learnfinish === 1">已学完</div>
          <div v-if="scope.row.learnfinish === 2">已学完</div>
          <div v-if="scope.row.learnfinish > 2">
            {{ scope.row.learnfinish }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          <div v-if="scope.row.type === 1">视频</div>
          <div v-if="scope.row.type === 2">音频</div>
          <div v-if="scope.row.type === 3">文本</div>
          <div v-if="scope.row.type === 4">文档</div>
          <div v-if="scope.row.type === 5">音视频链接</div>
        </template>
      </el-table-column>
      <el-table-column prop="starttime" label="开始学习时间">
        <template slot-scope="scope">
          <div>{{ datetimeFormat(scope.row.starttime) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="finishtime" label="完成学习时间">
        <template slot-scope="scope">
          <div>{{ datetimeFormat(scope.row.finishtime) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="结束学习时间">
        <template slot-scope="scope">
          <div>{{ datetimeFormat(scope.row.ctime) }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import * as api from '@/api/learningRecord/learningRecord'
import * as api2 from '@/api/courseware/checkCourseware'
export default {
  computed: {
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  data() {
    return {
      activeNames: [],
      albumId: this.$route.query.id,
      form: {
        type: '',
        courseName: '',
        uname: '',
        fullName: '',
      },
      typeList: [
        { label: '视频', value: '1' },
        { label: '文档', value: '2' },
        { label: '练习', value: '3' },
        { label: '测验', value: '4' },
        { label: '考试', value: '5' },
        { label: '资料', value: '6' },
      ],
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      selectedList: [],
      roleType:0 // 角色类型 为60需要隐藏的功能

    }
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  created() {
    this.initForm = { ...this.form }
    this.getFindUserByUid()
  },
  methods: {
    //搜索的折叠面板
    toggle() {
      if (this.activeNames.length > 0) {
        this.activeNames = []
        window.removeEventListener('keyup', this.enterQuery)
      } else {
        this.activeNames = ['1']
        window.addEventListener('keyup', this.enterQuery)
      }
    },
    search() {
      this.pageObj.page = 1
      this.getLearnRecord()
    },
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },
    delAll() {
      this.form = { ...this.initForm }
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getCourseRecordList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getCourseRecordList()
    },
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur()
      }
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    datetimeFormat(val) {
      if (!val) {
        return ''
      }
      const dt = new Date(val)
      const y = dt.getFullYear()
      const m = (dt.getMonth() + 1 + '').padStart(2, '0')
      const d = (dt.getDate() + '').padStart(2, '0')

      const hh = (dt.getHours() + '').padStart(2, '0')
      const mm = (dt.getMinutes() + '').padStart(2, '0')
      const ss = (dt.getSeconds() + '').padStart(2, '0')
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    async getLearnRecord() {
      console.log(' this.albumId', this.albumId)
      const { code, data } = (
        await api.getLearnRecord({
          ...this.pageObj,
          ...this.form,
          albumId: this.albumId,
        })
      ).data
      if (code === 100000) {
        this.tableData = data.list || []
      } else {
        this.$message.error('系统繁忙')
      }
    },
    exportLearnRecord() {
      window.open(
        `${this.url}/zkfz/elAlbum/exportLearnRecord?albumId=${this.albumId}&type=${this.form.type}&courseName=${this.form.courseName}&uname=${this.form.uname}&fullName=${this.form.fullName}`
      )
    },
    async getFindUserByUid(){
      const { code, data } = (await api2.getFindUserByUid(this.getUId)).data
      if (code === 100000) {
        console.log('userType222',data)
        let type = data.type.split(',');
        let flag = false;
        if(type.length>0){
          type.forEach(item=>{
             if(item==='60'){
               flag = true;
             }
          })
        }
        if(flag){
          this.roleType = 60
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
.table_control {
  display: flex;
  justify-content: space-between;
  color: #409eff;
  .table_control_item {
    cursor: pointer;
  }
}
</style>
